import React from 'react';
import { useHistory } from 'react-router-dom';
import Typography from 'new/elements/Typography';
import { ChipBadge } from 'new/elements/ChipBadge';
import { useFlowCategoriesRepository } from 'new/state/flowCategories';
import { ReactComponent as WarningIcon } from 'new/components/icons/warning.svg';
import { ReactComponent as DatabaseIcon } from 'new/elements/flows/Databases/assets/database.svg';
import UncategorizedFlowsSkeleton from './UncategorizedFlowsSkeleton';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';

import styles from './UncategorizedFlowsCard.module.scss';

const handleClick = (history: any) => () =>
  history.push(`${ROUTE_REDESIGN}${ROUTE_CONNECT}/projects/uncategorized`);

const UncategorizedFlowsCard = () => {
  const history = useHistory();
  const { getTotalFlowWithoutProjects, getFlowsWithoutProjects } = useFlowCategoriesRepository();

  const totalFlowWithoutProjects = getTotalFlowWithoutProjects();
  const { loading } = getFlowsWithoutProjects();

  if (loading) {
    return <UncategorizedFlowsSkeleton />;
  }

  const click = totalFlowWithoutProjects === 0 ? undefined : handleClick(history);

  const containerStyle =
    totalFlowWithoutProjects === 0 ? styles.cardContainerDisabled : styles.cardContainer;

  return (
    <div className={containerStyle} onClick={click}>
      <div className={styles.cardContent}>
        <div className={styles.leftSection}>
          <div className={styles.warningIcon}>
            <WarningIcon />
          </div>
          <div className={styles.contentArea}>
            <div className={styles.titleRow}>
              <Typography variant="subheading2" className={styles.title}>
                Uncategorized Flows
              </Typography>
              <ChipBadge label="Needs Organization" color="warning" />
            </div>
            <p className={styles.description}>
              Data flows that haven't been assigned to a project yet. Consider organizing these
              flows into appropriate projects.
            </p>
          </div>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.statsContent}>
            <DatabaseIcon className={styles.databaseIcon} />
            <span className={styles.countNumber}>{totalFlowWithoutProjects}</span>
            <Typography variant="caption" className={styles.countLabel}>
              Data Flows
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UncategorizedFlowsCard;
